<template>
  <div class="container-custom">
    <v-form ref="form" @submit.prevent="saveHandler">
      <Breadscrumbs
        :links="[
          {
            name: 'ApplicationCenter',
            to: {
              name: 'ApplicationCenter'
            }
          },
          {
            name: 'Create',
            to: {
              name: 'ApplicationCreate',
            }
          }
        ]"
      ></Breadscrumbs>
      <!-- page-actions -->
      <div class="page-actions">
        <h2>新增Application</h2>
        <v-spacer></v-spacer>
        <button class="btn mr-5" @click="cancelHandler">
          <span>取消</span>
        </button>
        <button class="btn btn-primary" type='submit'>
          <span>儲存</span>
        </button>
      </div>
    </v-form>
    <!-- Block 新增Application -->
    <ApplicationCreateEdit></ApplicationCreateEdit>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import ApplicationCreateEdit from '@/views/B-13__ApplicationDetail/c/ApplicationCreateEdit.vue';

export default {
  components: {
    Breadscrumbs,
    ApplicationCreateEdit,
  },
  computed: {
    ...mapState('application', ['application']),
  },
  created() {
    this.set_Application({});
  },
  methods: {
    ...mapActions('application', ['set_Application', 'save']),
    cancelHandler() {
      this.$router.push({ name: 'ApplicationCenter' });
    },
    saveHandler() {
      this.errors = [];
      if (this.$refs.form.validate()) {
        if (!this.application.title) {
          this.errors.push('標題 required.');
        } else if (!this.application.detail_page_title) {
          this.errors.push('Detail Page Title required.');
        } else if (!this.application.cover_photo) {
          this.errors.push('Cover Photo required.');
        } else if (!this.application.content) {
          this.errors.push('content required.');
        }
        if (this.errors.length > 0) {
          /* eslint-disable */
          alert(this.errors);
          /* eslint-disable */
          return false;
        }
        this.save(this.application).then(() => {
          this.$router.push({ name: 'ApplicationCenter' });
        });
      }
    },
  },
};
</script>

<style></style>
